import React, { FC } from 'react';
import { MenuBlock, SubMenu, MenuItem as MenuItemType } from 'moduleBase/types/Menu';
import { Tab } from 'react-bootstrap';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import classNames from 'classnames';
import { SupportInfo } from 'moduleBaseMenu/types/SupportInfo';
import { SupportContent } from 'moduleBaseMenu/components/desktop/SupportContent';
import { ToolsContent } from 'moduleBaseMenu/components/desktop/ToolsContent';
import { FaqContent } from 'moduleBaseMenu/components/desktop/FaqContent';

type PropsType = {
  blocks: MenuBlock[];
  activeId?: string[] | null;
  supportInfo: SupportInfo;
  tools: MenuItemType[];
  faq: MenuItemType[];
};

const TabsContent: FC<PropsType> = ({
  blocks,
  activeId,
  supportInfo,
  tools,
  faq,
}) => {
  const items = blocks.map((block) => {
    const menuItems = block.items.map((menuItem) => {
      const subMenu: SubMenu = {
        items: menuItem.items,
        className: 'list-unstyled',
        linkHolderClassName: 'd-flex align-items-center',
        linkClassName: 'text-truncate',
      };

      const subMenuDynamic: SubMenu = {
        blocks: menuItem.blocks,
        items: menuItem.dynamicItems,
        className: 'list-unstyled',
        linkHolderClassName: 'd-flex align-items-center',
        linkClassName: 'text-truncate',
      };

      return (
        <li
          className={classNames({ 'd-flex align-items-center': !menuItem.items })}
          key={menuItem.label}
        >
          <MenuItem
            {...menuItem}
            className="d-flex align-items-center"
            subMenu={subMenu}
            subMenuDynamic={subMenuDynamic}
            activeId={activeId}
          />
        </li>
      );
    });

    return (
      <Tab.Pane eventKey={block.id} key={block.id}>
        <div className="fs-22 mb-4 pb-3">
          {block.label}
        </div>
        <ul className="desktop-nav-list">
          {menuItems}
        </ul>
      </Tab.Pane>
    );
  });
  return (
    <Tab.Content className="mb-48p">
      {items}
      <SupportContent supportInfo={supportInfo} />
      <ToolsContent tools={tools} />
      <FaqContent faq={faq} />
    </Tab.Content>
  );
};

export { TabsContent };
